import React from "react";
import { Box } from "@mui/material";
import globalStyles from "../../../global";
import Banner from "../../globalCountries/countryhomepagescomponent/Banner";
import StatsSection from "../../globalCountries/countryhomepagescomponent/StatsSection";
import ServicesSection from "../../globalCountries/countryhomepagescomponent/ServicesSection";
import CountryBand from "../../globalCountries/countryhomepagescomponent/CountryBand";
import AppInfo from "../../globalCountries/countryhomepagescomponent/Appinfo";
import PromoSection from "../../globalCountries/countryhomepagescomponent/PromoSection";
import SuccessStory from "../../globalCountries/countryhomepagescomponent/SuccessStory";
import SomaliaLeadership from "../../globalCountries/countryhomepagescomponent/SomaliaLeadership";
import CountryBorder from "../../globalCountries/countryhomepagescomponent/Countryborder";
import News from "../../globalCountries/countryhomepagescomponent/News";
import FooterSr from "../components/Footersr";
// import Locations from "../../globalCountries/countryhomepagescomponent/Locations";
// import Brand from "../../globalCountries/countryhomepagescomponent/Brand";

const SrilankaHomePage = ({ countryCode }) => {
  return (
    <Box
      sx={{
        fontFamily: globalStyles.fonts.primary,
        color: globalStyles.colors.text,
      }}
    >
      <Banner countryCode={countryCode} />

      <StatsSection countryCode={countryCode} />

      <ServicesSection countryCode={countryCode} />

      <CountryBand countryCode={countryCode} />

      <SomaliaLeadership countryCode={countryCode} />

      <SuccessStory countryCode={countryCode} />

      <News countryCode={countryCode} />

      {/* <Brand /> */}

      <AppInfo countryCode={countryCode} />

      <CountryBorder countryCode={countryCode} />

      <PromoSection countryCode={countryCode} />
      {/* <Locations country={countryCode} /> */}
<FooterSr/>
    </Box>
  );
};

export default SrilankaHomePage;
